import React from "react";
import styled from "styled-components";
import { Trash2 } from "lucide-react";
import Button from "./Button";

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(210, 105, 30, 0.08);
  border: 1px solid #f5f5f5;
`;

const TableHeader = styled.thead`
  background-color: #ffffff;
`;

const HeaderRow = styled.tr`
  border-bottom: 2px solid #d2691e;
  background: linear-gradient(135deg, #fff8f2 0%, #ffffff 100%);
`;

const HeaderCell = styled.th`
  padding: 18px 16px;
  text-align: center;
  font-family: "Pretendard", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #d2691e;
  text-transform: uppercase;
  letter-spacing: 0.8px;
`;

const TableBody = styled.tbody``;

const BodyRow = styled.tr`
  transition: all 0.2s ease;

  &:hover {
    background-color: #fff8f2;
    transform: scale(1.001);
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

const BodyCell = styled.td`
  padding: 16px;
  text-align: center;
  font-family: "Pretendard", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #2d2d2d;
  vertical-align: middle;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #6b6b6b;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #fff8f2;
    color: #dc3545;
    transform: scale(1.15);
  }
`;

const ActionButton = styled(Button)`
  font-size: 16px;
  padding: 8px 16px;
`;

const Table = ({ columns, data, onDelete, onAction }) => {
  return (
    <TableContainer>
      <StyledTable>
        <TableHeader>
          <HeaderRow>
            {columns.map((column, index) => (
              <HeaderCell key={index}>{column.header}</HeaderCell>
            ))}
          </HeaderRow>
        </TableHeader>
        <TableBody>
          {data.map((row, rowIndex) => (
            <BodyRow key={rowIndex}>
              {columns.map((column, colIndex) => (
                <BodyCell key={colIndex}>
                  {column.key === "actions" ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      {column.render ? (
                        column.render(row, rowIndex)
                      ) : (
                        <>
                          {onDelete && (
                            <DeleteButton
                              onClick={() => onDelete(row, rowIndex)}
                            >
                              <Trash2 size={20} />
                            </DeleteButton>
                          )}
                        </>
                      )}
                    </div>
                  ) : column.render ? (
                    column.render(row[column.key], row, rowIndex)
                  ) : (
                    row[column.key] || "-"
                  )}
                </BodyCell>
              ))}
            </BodyRow>
          ))}
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
};

export default Table;
